/**
 * CardsCarousel Component
 *
 * @module components/cards-carousel
 */

import Component from './component';
import Slider from './slider';
import CardFocusVisible from './card-focus-visible';
import utils from '../utils';

// component name as used in `data-component` attribute.
const COMPONENT_NAME = 'cards-carousel';

// min width to switch to grid mode.
const DESKTOP_BREAKPOINT = utils.breakpoints.aggreko['medium-large'];
// identifier class to whether or not switch to grid mode on desktop, can be added to cards-carousel itself or to parent component.
const GRID_ON_DESKTOP_CLASS = '-grid-desktop';
// class to be added when on grid mode.
const GRID_MODE_CLASS = '-grid-mode';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * ComponentName component class
   */
  class CardsCarousel extends Component {
    constructor(element, options = {}) {
      super(element, options);
      this.name = COMPONENT_NAME;
    }

    /**
     * Main initializer
     * 
     * @returns void
     */
    init() {
      const el = this.element;

      if (el.hasClass(this.initializedClass)) {
        return;
      }

      el.addClass(this.initializedClass);

      this._initGridOnDesktop();
      this._initFocusVisible();

      // initial resize update 
      this._onResize();
    }

    /**
     * Init Slider.
     */
    initSlider() {
      this.slider = new Slider(this.element, {
        adjustPageSize: true
      });

      this.slider.init();
    }

    /**
     * Focus visible (keyboard focus) functionality.
     */
    _initFocusVisible() {
      new CardFocusVisible(this.element, {
        cardSelector: CardsCarousel.selectors.card
      });
    }

    /**
     * Init 'grid on Desktop' variant functionality.
     */
    _initGridOnDesktop() {
      const el = this.element;
      const elParent = this.getParentComponent();

      // whether or not to show as grid on Desktop.
      this._asGridOnDesktop = !!(el.hasClass(GRID_ON_DESKTOP_CLASS) || (elParent && elParent.hasClass(GRID_ON_DESKTOP_CLASS)));
      this._gridMode = null;

      if (this._asGridOnDesktop) {
        window.addEventListener('resize', utils.debounce(this._onResize.bind(this), 200));
      }
    }

    /**
     * Window Resize event handler.
     */
    _onResize() {
      // For 'grid on Desktop' variant, check if we should switch to Grid mode or Slider mode after window resize.
      if (this._asGridOnDesktop) {
        const wasGridMode = this._gridMode;
        this._updateBreakpoint();

        if (wasGridMode !== this._gridMode) {
          if (this._gridMode) {
            this.element.addClass(GRID_MODE_CLASS);

            if (this.slider) {
              this.slider.destroySlider();
              this.slider = null;
            }
          }
          else {
            this.element.removeClass(GRID_MODE_CLASS);
            if (!this.slider) {
              this.initSlider();
            }
          }
        }
      }
      // Not a 'grid on Desktop' variant, just initSlider. 
      //   This runs only once because only 'grid on Desktop' variant listen to resize event.
      else {
        this.initSlider();
      }
    }

    /**
     * Determine if we should show the Cards as grid.
     */
    _updateBreakpoint() {
      this._gridMode = false;
      if (this._asGridOnDesktop) {
        this.viewportWidth = $(window).width();
        this._gridMode = false;
        if (this.viewportWidth >= DESKTOP_BREAKPOINT) {
          this._gridMode = true;
        }
      }
    }
  }

  CardsCarousel.selectors = {
    card: '.card'
  };

  return CardsCarousel;
})(jQuery, window);